import React from 'react';
import toast from 'react-hot-toast';
import CryptoJS from 'crypto-js';

const AuthSign = async (
  values,
  history,
  setIsLoggedIn,
  setUsername,
  apiGlobalforLogin,
  setRestaurantId,
  setUserId,
  setStatusCode,
  setType,
  setPermissionsAccess,
  setCurrencyCode,
  setCountryId,
) => {
  const { username, passwords } = values;

  // const loginData = new URLSearchParams({
  //   email: username,
  //   password: passwords,
  // }).toString();

  const formData = new FormData();
  formData.append('email', username);
  formData.append('password', passwords);

  try {
    const response = await fetch(`${apiGlobalforLogin}/restaurant/login_api.php`, {
      method: 'POST',
      body: formData,
      // headers: {
      //   'Content-Type': 'application/json',
      // },
    });

    const result = await response.json();

    if (result?.message === 'Success' && result?.status && result?.token) {
      // Clear old data before setting new session
      localStorage.clear();

      // Encrypt constants
      const secretKey = 'T4$Bv9#Aa@QWz8m&5!Lpo1kHsTz4jL2';

      // Save in context
      setIsLoggedIn(true);
      setUsername(result?.user_name);
      setRestaurantId(result?.restaurant_id);
      setStatusCode(result?.status_approve);
      setUserId(result?.user_id);
      setType(result?.type);
      setPermissionsAccess(result?.permission || {});
      setCurrencyCode(result?.currency_code);
      setCountryId(result?.country_id);

      // Encrypt and store in localStorage
      localStorage.setItem('authToken', result.token);

      const encryptedUserName = CryptoJS.AES.encrypt(result.user_name, secretKey).toString();
      localStorage.setItem('resuserName', encryptedUserName);

      const encryptedPermissions = CryptoJS.AES.encrypt(JSON.stringify(result.permission), secretKey).toString();
      localStorage.setItem('respermissions', encryptedPermissions);

      const encryptedUserId = CryptoJS.AES.encrypt(result.user_id.toString(), secretKey).toString();
      localStorage.setItem('resuserid', encryptedUserId);

      const encryptedstatusCode = CryptoJS.AES.encrypt(result.status.toString(), secretKey).toString();
      localStorage.setItem('resstatuscode', encryptedstatusCode);

      const encryptedResID = CryptoJS.AES.encrypt(result.restaurant_id.toString(), secretKey).toString();
      localStorage.setItem('restauresID', encryptedResID);

      const encryptedType = CryptoJS.AES.encrypt(result.type.toString(), secretKey).toString();
      localStorage.setItem('restype', encryptedType);

      const encryptedCountryId = CryptoJS.AES.encrypt(result?.country_id.toString(), secretKey).toString();
      localStorage.setItem('cid', encryptedCountryId);

      const encryptedCurrencyCode = CryptoJS.AES.encrypt(result?.currency_code, secretKey).toString();
      localStorage.setItem('99117114114101110991219599111100101', encryptedCurrencyCode);
       // Ascii value of "currency_code"

      toast.success('Login successful!');

      // ✅ Redirect *only after* everything is saved
      setTimeout(() => {
        history.push('/app_dashboard');
      }, 500);
    } else {
      toast.error('User Not Authenticated');
      setIsLoggedIn(false);
    }
  } catch (error) {
    toast.error('Login failed. Please try again.');
    console.error('Login error:', error);
    setIsLoggedIn(false);
  }
};

export default AuthSign;


